import { render, staticRenderFns } from "./SimBajaIndividualPantalla.vue?vue&type=template&id=3cc83a88&"
import script from "./SimBajaIndividualPantalla.vue?vue&type=script&lang=ts&"
export * from "./SimBajaIndividualPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports